export const defaultVisualEtiqueta = () => {
    return {
        idioma: 'Espanol',
        version: false,
        formatoEtiqueta: 'Pdf',
        empresa: false,
        regla: false,
        fabfecha: false,
        rol: false,
        tipoproducto: false,
        cabecera: false,
        tipoEtiqueta: false,
        cantidad: false,
        qr: true,
        fecha_fab: true,
        slq_location_id: null
    }
}
export const defaultpdfTE = () => {
    return {
        idioma: 'Espanol',
        uuid: '',
        version: false,
        empresa: 1,
        rol: false,
        fabfecha: false,
        tipoproducto: false,
        tipoEtiqueta: '',
        cantidad: null,
        qr: false,
        medidaEtiquetaTexto: '',
        tipoEtiquetaTexto: '',
        multiplesPaginasMasivo: false,
        in_use: null
    }
}

// datos iniciales para las etiquetas Baker
export const initialDataLabelsBaker = () => {
    return {
        company     : 111,
        typeLabel   : '',
        cant        : 1,
        useQr       : true,
        useRule     : false,
        configurableVariables: null,
        configurableVariablesId: null,
        orientation: 'portrait'
    }
}

// datos iniciales para las etiquetas Baker: opciones del formulario
export const initialDataLabelsBakerOptionsToForm = () => {
    return {
        type: 'Etq_3x4_5_Micro',
        types: [
            {
                value: 'Etq_3x4_5_Micro',
                title: 'Etq 3 x 4.5 Micro',
                cants: [
                    { value: 1, label: 1 },
                    { value: 2, label: 2 },
                    { value: 3, label: 3 },
                    { value: 4, label: 4 }
                ],
                comments: ''
            },
            {
                value: 'Etq_7_4x5_2_Pequeña',
                title: 'Etq 7,4 x 5,2 Pequeña',
                cants: [],
                comments: 'Hasta 3 litros'
            },
            {
                value: 'Etq_7_4x10_5_Mediana',
                title: 'Etq 7,4 x 10,5 Mediana',
                cants: [],
                comments: 'Más de 3 litros, pero sin exceder 50 litros'
            },
            {
                value: 'Etq_14_5x10_5_Grande',
                title: 'Etq 14.5 x 10,5 Grande',
                cants: [],
                comments: 'Más de 50 litros, pero sin exceder 500 litros'
            },
            {
                value: 'Etq_21_x14_8_Extra_Grande',
                title: 'Etq 21 x 14.8  Extra-Grande',
                cants: [],
                comments: 'Más de 500 litros'
            },
        ],
        cant: 1,
        comments: ''
    };
}

// datos iniciales de medidas de et para masivas
export const initialMeasures = () => {
    return  [
        {
            value: 'A',
            tipo: 'verticales',
            text: 'Verticales ET Pequeña (Aprox 5x6cm - 5x7cm)',
            multiple: [3, 6, 9]
        },
        {
            value: 'B',
            tipo: 'verticales',
            text: 'Verticales ET Mediana (Aprox 7x10cm - 7x12cm)',
            multiple: [2, 4]
        },
        {
            value: "C",
            tipo: "verticales",
            text: "Verticales ET Grande (Aprox 18x12cm)",
            multiple: [],
        },
        {
            value: "D",
            tipo: "verticales",
            text: "Verticales ET Extra-Grande (Aprox 22x18cm)",
            multiple: [],
        },
        {
            value: "E",
            tipo: "resolucion",
            text: "Resolución 0773 ET Pequeña (Aprox 7.4X5.2cm - 7.5x6cm)",
            multiple: [2, 4, 6],
        },
        {
            value: "F",
            tipo: "resolucion",
            text: "Resolución 0773 ET Mediana (Aprox 10.5X7.4cm - 10.8X7.6cm)",
            multiple: [2],
        },
        {
            value: "G",
            tipo: "resolucion",
            text: "Resolución 0773 ET Grande (Aprox 14.8x10.5cm)",
            multiple: [],
        },
        {
            value: "H",
            tipo: "resolucion",
            text: "Resolución 0773 ET Extra-Grande (Aprox 21x14.8cm)",
            multiple: [],
        },
        {
            value: "I",
            tipo: "halliburton",
            text: "Halliburton ET Pequeña (Aprox 10.8X4.65cm)",
            multiple: [2, 3],
        },
        {
            value: "J",
            tipo: "halliburton",
            text: "Halliburton ET Mediana (Aprox 14X10.5cm)",
            multiple: [2],
        },
        {
            value: "K",
            tipo: "halliburton",
            text: "Halliburton ET Grande (Aprox 21.5x14cm)",
            multiple: [],
        },
        {
            value: "Etq_3x4_5_Micro",
            title: "Etq 3 x 4.5 Micro",
            tipo: "baker",
            text: "Baker Etq 3 x 4.5 Micro",
            cants: [
                { value: 1, label: 1 },
                { value: 2, label: 2 },
                { value: 3, label: 3 },
                { value: 4, label: 4 },
            ],
            comments: "",
              multiple: [],
        },
        {
            value: "Etq_7_4x5_2_Pequeña",
            title: "Etq 7,4 x 5,2 Pequeña",
            tipo: "baker",
            text: "Baker Etq 7,4 x 5,2 Pequeña",
            cants: [],
            comments: "Hasta 3 litros",
              multiple: [],
        },
        {
            value: "Etq_7_4x10_5_Mediana",
            title: "Etq 7,4 x 10,5 Mediana",
            tipo: "baker",
            text: "Baker Etq 7,4 x 10,5 Mediana",
            cants: [],
            comments: "Más de 3 litros, pero sin exceder 50 litros",
              multiple: [],
        },
        {
            value: "Etq_14_5x10_5_Grande",
            title: "Etq 14.5 x 10,5 Grande",
            tipo: "baker",
            text: "Baker Etq 14.5 x 10,5 Grande",
            cants: [],
            comments: "Más de 50 litros, pero sin exceder 500 litros",
              multiple: [],
        },
        {
            value: "Etq_21_x14_8_Extra_Grande",
            title: "Etq 21 x 14.8  Extra-Grande",
            tipo: "baker",
            text: "Baker Etq 21 x 14.8  Extra-Grande",
            cants: [],
            comments: "Más de 500 litros",
              multiple: [],
        },

        {
            value: "N",
            tipo: "verticales",
            text: "Verticales ET Mini (Aprox 2x4.5cm)",
            multiple: [3, 6, 9, 12, 15, 18, 21, 24, 27, 30],
        },
        {
            value: "O",
            tipo: "resolucion",
            text: "Resolución 0773 ET Micro (Aprox 3X3.5cm)",
            multiple: [4, 8, 12, 16, 20, 24, 28],
        },
    ];
};

export default {
    error: false,
    etiquetasArchivo: [],
    etiquetasProcesadas: [],
    medidas: initialMeasures(),
    empresas: [],
    idiomas: [
        { value: "Espanol", text: "Español" },
        { value: "Ingles", text: "Ingles" },
        { value: "Portugues", text: "Portugues" },
    ],
    formatosEtiqueta: [
        { value: "Pdf", text: "Pdf" },
        { value: "Word", text: "Word" },
    ],
    check_qr: 1,
    mini: false,
    VisualEmpresa: defaultVisualEtiqueta(),
    dataLabelsBaker: initialDataLabelsBaker(),
    labelsBakerOptionsToForm: initialDataLabelsBakerOptionsToForm(),
    orientations: [
        {
            value: "portrait",
            text: "Vertical",
        },
        {
            value: "landscape",
            text: "Horizontal",
        },
    ], // Orientaciones disponibles (Vertical: portrait, Horizoltal: landscape)
    orientation: {
        value: "portrait",
        text: "Vertical",
    },
    version: 6,
    dirEtiqueta: "",
    advertenciaEtMultiple: "",
    pdfet: defaultpdfTE(),
    optempresa: [{ value: "", text: "" }],
    cargando_datos_select: false,

    empresaAsignada: false,
};
